import { Button } from '../../ui/Button'
import React from 'react'

interface ScheduleVisitStepProps {
  titulo?: string
  descripcion?: string
  onFinalize?: () => void
}

const ScheduleContractSuccess: React.FC<ScheduleVisitStepProps> = ({
  onFinalize,
  titulo,
  descripcion,
}) => {
  const handleFinalize = () => {
    if (onFinalize) {
      onFinalize()
    }
  }

  return (
    <>
      {/* Header */}
      <div className="text-center mb-8">
        <h1 className="text-2xl font-bold text-gray-900 mb-4">{titulo}</h1>
        <p className="text-gray-600">{descripcion}</p>
      </div>

      {/* Action Buttons */}
      <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 pt-6 max-w-xs mx-auto">
        <Button
          type="button"
          variant="outline"
          onClick={handleFinalize}
          className="flex-1"
        >
          Finalizar
        </Button>
      </div>
    </>
  )
}

export default ScheduleContractSuccess
